export const signUpIdpSelectionUrl = '/campaign/pmaxlitelanding/signup';
export const signInIdpSelectionUrl = '/campaign/pmaxlitelanding/signin';
export const userInvitationIdpSelectionUrl = '/campaign/pmaxlitelanding/userinvitation';
export const emailExistsErrorUrl = '/campaign/pmaxlitelanding/userexists';
export const loginErrorUrl = '/campaign/pmaxlitelanding/loginerror';
